<template>
    <div>
        <breadCrumb 
            :icon="' fa-clipboard-list-check'"
            :category="$t(`sideNav.navMySalon`)"
            :subCategory="$t(`subMenu.my_salon_branding`)"
            :subSubCategory="$t(`brand_submenu.brand_setup_checklist`)">
        </breadCrumb>
        <div v-if="!addChecklistToggle" class="text-right mt-3 mr-5">
            <button class="btn buttons-csv buttons-html5 btn-outline-primary" type="button" :title="$t('button_link.add') + $t(`brand_submenu.brand_setup_checklist`)" @click="addChecklistToggle = !addChecklistToggle">
                <span class="fal fa-plus mr-2"></span>
                <span>{{$t('button_link.add')}}{{$t(`brand_submenu.brand_setup_checklist`)}}</span>
            </button>
        </div>
        <div v-if="addChecklistToggle" class="px-3 px-sm-5 py-4">
            <div class="panel mb-0">
                <div class="panel-hdr">
                    <h2>{{$t('header.add')}}{{$t(`brand_submenu.brand_setup_checklist`)}}</h2>
                </div>
                <div class="panel-container">
                    <div class="panel-content">
                        <checklistForm :isEdit="false" @submitForm="addChecklist" @returnChecklist="closeModal"></checklistForm>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="!addChecklistToggle" class="px-3 px-sm-5 py-4">
            <div class="panel mb-0">
                <div class="panel-hdr pt-4 p-3">
                    <div class="ml-auto text-right mb-3">
                        <exportCSV class="link btn buttons-csv buttons-html5 btn-primary mr-2"
                            :data="exportData"
                            :fields="exportFields"
                            :header="exportHeaders"
                            type="csv"
                            :escapeCsv="false"
                            :name="exportFileName">
                            <span>CSV</span>
                        </exportCSV>
                        <!-- <button class="btn buttons-csv buttons-html5 btn-secondary ml-2" type="button" title="Generate PDF">
                            <span class="mr-3">PDF</span>
                            <i class="arrow-down fas fa-angle-down"></i> 
                        </button> -->
                    </div>
                </div>
                <div class="panel-container">
                    <div class="panel-content">
                        <div v-if="isSpinnerShow" class="d-flex justify-content-center mt-3 mb-3">
                            <b-spinner label="Loading..."></b-spinner>
                        </div>
                        <div class="panel-tag mt-3" v-if="!isSpinnerShow && totalEntries == 0">{{$t('table.no_records')}}</div>
                        <div v-if="!isSpinnerShow && totalEntries != 0" class="dataTables_wrapper dt-bootstrap4">
                            <div class="row justify-content-end mt-2">
                                <div class="col-auto pt-2">
                                    <span>{{$t('table.pagination', {'startPage': startPage, 'endPage': endPage, 'totalEntries': totalEntries,})}}</span>
                                </div>
                                <div class="col-auto">
                                    <b-pagination class="ml-3" v-model="currentPage" :per-page="perPage" :total-rows="totalEntries" @input="handlePagination" aria-controls="tblProductItems"></b-pagination>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-12 overflow-auto">
                                    <b-table striped hover bordered :fields="fields" :items="checkLists" responsive>
                                        <template #cell(index)="data">
                                            {{ data.index + startPage }}
                                        </template>
                                        <template #cell(title)="data">
                                            <a class="text-primary fw-500 link" @click="showEditChecklist(data.item)">{{data.item.title}}</a>
                                        </template>
                                        <template #cell(isEnable)="data">
                                            <span class="badge" :class="data.item.isEnable == 1 ? 'badge-primary' : 'badge-secondary'">
                                                {{data.item.isEnable == 1 ? $t('table.value.enable') : $t('table.value.disable')}}
                                            </span>
                                        </template>
                                    </b-table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>   
            </div>
        </div>
        <div :class="{'show': editToggleModal }" class="modal fade">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header border-bottom">
                        <h5 class="modal-title h4">{{$t('header.edit')}}{{$t(`brand_submenu.brand_setup_checklist`)}}
                            <small class="m-0 text-muted">{{$t(`brand_submenu.brand_setup_checklist`)}}: '{{cTitle}}'</small>
                        </h5>
                        <button type="button" class="close" @click="editToggleModal = false">
                            <span aria-hidden="true"><i class="fal fa-times"></i></span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <checklistForm ref="editChecklist" :isEdit="true" @submitForm="editChecklist"></checklistForm>
                    </div>
                </div>
            </div>
        </div>
        <div :class="{'show': deleteToggleModal }" class="modal fade">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header border-bottom">
                        <h5 class="modal-title h4">Delete Checklist</h5>
                        <button type="button" class="close" @click="deleteToggleModal = !deleteToggleModal">
                            <span aria-hidden="true"><i class="fal fa-times"></i></span>
                        </button>
                    </div>
                    <div class="modal-body pb-0">
                        <p>Are you sure you want to delete "{{cTitle}}"?</p>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary waves-effect waves-themed" @click="deleteToggleModal = !deleteToggleModal">No</button>
                        <button id="btnDeleteYes" type="button" class="btn btn-primary waves-effect waves-themed">Yes</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import BreadCrumb from './../../Bread_Crumb'
import axios from 'axios'
import moment from 'moment'
import ChecklistForm from './Brand_Checklist_Form'
import expTbl from '@/assets/js/dashboard/export-table-header.js'
import {setReturnData, handleSessionExpired, handleError} from '@/assets/js/dashboard/dashboard.js'
export default {
    name: 'brandChecklist',
    components:{
        ChecklistForm, BreadCrumb
    },
    data(){
        return{
            category: 'My Salon', subCategory: 'Branding', subSubCategory: 'Checklist',
            addChecklistToggle: false, editToggleModal: false, deleteToggleModal: false, 
            isSpinnerShow: false,
            isError: false, success: false, message: "",
            checkLists: [],
            cID: 0, cTitle: "",
            exportHeaders: [], exportData: [], exportFileName: "",
            page: 0, totalEntries: 0, totalPage: 0, startPage: 1, endPage: 0, perPage: 100, currentPage: 1,
            
        }
    },
    computed:{
        fields(){
            return[
                {key: "index", label: "#", thClass: 'thead-themed align-middle'},
                {key: "title", label: this.$i18n.t('table.header.title'), thClass: 'thead-themed align-middle', sortable: true},
                {key: "category", label: this.$i18n.t('table.header.category'), thClass: 'thead-themed align-middle', sortable: true},
                {key: "isEnable", label: this.$i18n.t('table.header.enable'), thClass: 'thead-themed align-middle'}
            ]
        },
        exportFields(){
            var ret = {}
            ret["#"] = "index"
            ret[(this.$i18n.t('table.header.title')).toUpperCase()] = "title"
            ret[(this.$i18n.t('table.header.category')).toUpperCase()] = "category"
            ret[(this.$i18n.t('table.header.enable')).toUpperCase()] = "isEnable"
            return ret
        },
    },
    watch:{
        "$i18n.locale"(val){
            this.getExportData()
        }
    },
    methods:{
        closeModal(isError){
            if(!isError){
                this.addChecklistToggle = this.editToggleModal = this.deleteToggleModal = false;
                this.setCheckList();
            }
            this.$parent.isModalShow = false;
        },
        async setCheckList(){
            this.isSpinnerShow = true;

            var result = await this.getChecklist();
            var retData = setReturnData(result, result.length, this.page)

            this.checkLists = retData.result;
            this.totalEntries = retData.count;
            this.totalPage = retData.totalPage;

            this.startPage = retData.startPage;
            this.endPage = retData.endPage;

            await this.getExportData();
            this.isSpinnerShow = false;
        },
        async getChecklist(){
            let $vm = this;
            let QUERY_STRING =  "?page=" + $vm.page 
            const url =  this.$api.BRAND_CHECKLIST + QUERY_STRING;

            var result = []
            await $vm.$axios({
                method: 'get', 
                url: url,
                baseURL: $vm.$axios.defaults.baseURL, 
                headers: {token: $vm.$session.get('token')}
            })
            .then(function(response) {
                result = response.data.checklist
            })
            .catch((err) => {
                var error = err.response.data.error;
                if(error == $vm.$api.INVALID.TOKEN){
                    handleSessionExpired();   
                }
            })
            return result
        },
        addChecklist(data){
            let $vm = this
            this.$axios({
                method: 'post', 
                url: this.$api.BRAND_CHECKLIST,
                baseURL: this.$axios.defaults.baseURL, 
                headers: {token: this.$util.getSessionToken()},
                data: data
            })
            .then((response) => {
                if(response.status == 200){
                    var retData = response.data.checklist[0];
                    var message = "'" + retData.title + "'" + $vm.$i18n.t('message.success.add')
                    $vm.$parent.setModal($vm, false, true, message);
                }
            })
            .catch((err) => {
                var error = err.response.data.error;
                if(error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();   
                }else{
                    $vm.$parent.setModal($vm, true, true, $vm.$i18n.t('message.error.system_error'));
                }
            })
        },
        showEditChecklist(item){
            this.cID = item.checkListID;
            this.cTitle = item.title; 
            this.editToggleModal = true;
            this.$refs.editChecklist.editChecklistDetails(item);
        },
        editChecklist(data){
            let $vm = this
            let QUERY_STRING =  "/" + this.cID + this.$api.UPDATE
            const url =  this.$api.BRAND_CHECKLIST + QUERY_STRING;

            this.$axios({
                method: 'post', 
                url: url,
                baseURL: this.$axios.defaults.baseURL, 
                headers: {token: this.$util.getSessionToken()},
                data: data
            })
            .then((response) => {
                if(response.status == 200){
                    var retData = response.data.checklist[0];
                    var message = "'" + retData.title + "'" + $vm.$i18n.t('message.success.update')
                    $vm.$parent.setModal($vm, false, true, message);
                }
            })
            .catch((err) => {
                var error = err.response.data.error;
                if(error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();   
                }else{
                    $vm.$parent.setModal(this, true, true, $vm.$i18n.t('message.error.system_error'));
                }
            })
        },
        deleteChecklist(id, title){
            let $vm = this;
            this.cTitle = title;
            // for(var i=0; i<this.checkLists.length; i++){
            //     if(id == this.checkLists[i].checkListID){
            //         this.cTitle = this.checkLists[i].title;
            //         break;
            //     }
            // }   
            this.deleteToggleModal = true;

            document.getElementById('btnDeleteYes').onclick = function(){
                const url = "https://m5.tunai.io/business/setting/checklist/" + id + "/delete";

                var data = {};
                var config = { headers: {token: $vm.$session.get('token')}}

                axios.post(url, data, config)
                .then((response) => {
                    if(response.status == 200){
                        $vm.deleteToggleModal = false;
                        $vm.message = "Checklist deleted successfully."
                        $vm.success = true;
                    }
                })
                .catch((err) => {
                    console.log(err)
                })
            }
        },
        handlePagination(pg){
            if(pg != null){
                this.page = pg - 1;
                this.setCheckList();
                //document.getElementById('btnToTop').click(); 
            }
        },
        async getExportData(){
            let $vm = this;
            var result = []
            await $vm.$axios({
                method: 'get', 
                url: this.$api.BRAND_CHECKLIST ,
                baseURL: $vm.$axios.defaults.baseURL, 
                headers: {token: $vm.$session.get('token')}
            })
            .then(function(response) {
                result = response.data.checklist
            })
            .catch((err) => {
                var error = err.response.data.error;
                if(error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();   
                }
            })
            this.setExportData(result);
        },
        setExportData(data){
            this.exportData = []
            for(var i=0; i<data.length; i++){
                this.exportData.push({
                    index: i+1,
                    title: data[i].title,
                    category: data[i].category,
                    isEnable: data[i].isEnable == 1 ? this.$i18n.t('table.value.enable') : this.$i18n.t('table.value.disable'),
                })
            }
            let header = this.$msg.REPORT.HEADER + this.$i18n.t('subMenu.my_salon_branding') + this.$i18n.t(`brand_submenu.brand_setup_checklist`)
            this.exportHeaders = [header, this.$i18n.t('table.report_generate') + moment().format(this.$msg.CST.DATE_TIME_24)," "];
            this.exportFileName =  header.split(" ").join("_") +  this.$msg.REPORT.CSV
        }
    },
    mounted(){
        let $vm = this;
        $vm.setCheckList();
    }
}
</script>

<style scoped>
.show{
    display: block;
}
</style>